<script>
import DatafileReportService from "@/api/services/datafileReport.service.js";
import { MeanChart } from "@/redem/datafiles/result-charts.js";
import { GLOBALS } from "@/shared/util/globals.js";

export default {
  props: {
    datafileId: String
  },
  data() {
    return {
      meanChartOptions: null,
      chartDataForCleanInformationScoreMeanChart: 0,
      chartDataForRawInformationScoreMeanChart: 0
    };
  },
  async created() {
    await this.fetchChartData();
    this.meanChartOptions = new MeanChart();
  },
  methods: {
    async fetchChartData() {
      const iScores = await DatafileReportService.getReportAverageInformationScore(
        this.datafileId,
        GLOBALS.reportPassword
      );
      this.$emit("finishLoading");
      this.chartDataForRawInformationScoreMeanChart = iScores[0];
      this.chartDataForCleanInformationScoreMeanChart = iScores[1];
    }
  }
};
</script>

<template>
  <div class="card" style="border: 1px solid #f5f5f5">
    <div class="card-body">
      <div class="card-title">
        {{ $t("qualityScoreWidgets.infomationScoreWidget.title") }}
      </div>
      <div class="card-text" style="height: 120px;">
        {{ $t("qualityScoreWidgets.infomationScoreWidget.description") }}
      </div>
      <div class="card-text">
        <div class="row mt-4">
          <div class="col-md-12 text-center">
            <b-tabs>
              <b-tab active lazy>
                <template v-slot:title>
                  {{ $t("datafileReport.cleaned") }}
                </template>
                <div>
                  <apexchart
                    ref="PSMeanChart"
                    class="apex-charts apexChartData"
                    type="radialBar"
                    height="250"
                    dir="ltr"
                    :series="[chartDataForCleanInformationScoreMeanChart]"
                    :options="meanChartOptions.chartOptions"
                  ></apexchart>
                </div>
              </b-tab>
              <b-tab lazy>
                <template v-slot:title>
                  {{ $t("datafileReport.raw") }}
                </template>
                <div>
                  <apexchart
                    ref="PSMeanChart"
                    class="apex-charts apexChartData"
                    type="radialBar"
                    height="250"
                    dir="ltr"
                    :series="[chartDataForRawInformationScoreMeanChart]"
                    :options="meanChartOptions.chartOptions"
                  ></apexchart>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
